__turbopack_context__.v({
  "howItWorks": "ReserveNowHowItWorks-module__Xh1s4q__howItWorks",
});
